<ng-template #indicator let-step let-index="index">
  @if (step.completed) {
    <rt-icon-circle
      [backgroundColor]="'colorBgSuccessDefault'"
      [iconName]="'check'"
      [iconColor]="'colorIconOntellentDefault'"
      [size]="'medium'"
    />
  } @else if (step.active) {
    <div class="indicator in-progress">
      {{ index }}
    </div>
  } @else {
    <div class="indicator next">
      {{ index }}
    </div>
  }
</ng-template>

@for (step of steps(); track step.id; let last = $last; let index = $index) {
  <div
    class="progress-step"
    [class.completed]="step.completed"
    [class.active]="step.active"
    [class.next]="!step.active && !step.completed"
  >
    <ng-container
      [ngTemplateOutlet]="indicator"
      [ngTemplateOutletContext]="{ $implicit: step, index: index + 1 }"
    />
    {{ step.label }}
  </div>

  @if (!last) {
    <rt-icon class="arrow" [name]="'keyboard-arrow-right'" />
  }
}
